module.exports = new __parcel__URL__("shop_machines_raijus_grave.f503b672.png").toString();